module.exports = __webpack_public_path__ + "img/idea-bg.1f99d62e.webp";